export default __webpack_public_path__ + "media/e948f355f5be949624b359f7a026825147314bbc06fca9300ed4e4b59b40637e.svg";